module.exports = {"id":"198715","name":"Sergio León","rating":"77","photo":"./data/images/photos/3/198715.png","club":{"name":"Real Betis","logo":"./data/images/clubs/RealBetis.png"},"positions":["BU","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergioLeon0.json
// module id = 3920
// module chunks = 0